export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8183.e07d756b.jpg";